import React, { useState, useEffect } from 'react';

import SuggestionDropdown from '../shared/SuggestionDropdown';
import { focusRef, matchOptions, scrollToElement } from '../shared/EventHelpers';
import { getIcon } from '../shared/FormatHelpers';

const SelectAppender = ({ iconName, setValue, options, inputRef, onSave, autoFocus, handleCancel }) => {
    const [userInput, setUserInput] = useState('');
    const [activeIndex, setActiveIndex] = useState(-1);
    const [matchedOptions, setMatchedOptions] = useState(options);
    const [showOptions, setShowOptions] = useState(!!autoFocus);
    const [shouldSave, setShouldSave] = useState(false);
    const icon = getIcon(iconName);

    useEffect(() => {
        autoFocus && focusRef(inputRef);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputRef]);

    useEffect(() => {
        setMatchedOptions(matchOptions(options, userInput));
        setActiveIndex(-1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInput, options]);

    useEffect(() => {
        if (shouldSave) {
            onSave && onSave();
            setShouldSave(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldSave]);

    const setSelectedItem = () => {
        if (activeIndex < 0 || activeIndex >= matchedOptions.length) {
            return;
        }
        if (matchedOptions[activeIndex].id) {
            setValue(matchedOptions[activeIndex]);
        } else {
            setValue(null);
        }
        setActiveIndex(-1);
        setUserInput('');
        setShowOptions(false);
        setShouldSave(true);
    };

    const scrollToIndex = (index) => {
        scrollToElement(`suggestion-${index}`);
    };

    const onMouseDown = (event) => {
        if (activeIndex >= 0) {
            setSelectedItem();
            event.preventDefault();
        }
    };

    const onKeyDown = (event) => {
        // Enter adds selected item
        if (event.keyCode === 13) {
            if (activeIndex >= 0) {
                setSelectedItem();
                event.preventDefault();
            } else {
                setShowOptions(false);
            }
        }

        // Up-arrow moves up in list
        else if (event.keyCode === 38) {
            if (activeIndex > -1) {
                setActiveIndex(activeIndex - 1);
                scrollToIndex(activeIndex - 1);
            }
            event.preventDefault();
        }

        // Down-arrow moves down in list
        else if (event.keyCode === 40) {
            if (activeIndex < matchedOptions.length) {
                setActiveIndex(activeIndex + 1);
                scrollToIndex(activeIndex + 1);
            }
            event.preventDefault();
        }

        // Esc closes dropdown
        else if (event.keyCode === 27) {
            handleCancel();
            event.preventDefault();
        }
    };

    const onBlur = () => {
        setUserInput('');
        setShowOptions(false);
    };

    const onFocus = () => {
        setShowOptions(true);
    };

    return (
        <div className='new-item-selector'>
            <div className='d-flex flex-nowrap'>
                {icon}
                <input
                    ref={inputRef}
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    onKeyDown={onKeyDown}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
            </div>
            <SuggestionDropdown
                {...{
                    suggestions: matchedOptions,
                    showSuggestions: showOptions,
                    activeIndex,
                    setActiveIndex,
                    onMouseDown,
                    disableScroll: !matchedOptions || matchedOptions.length < 10,
                }}
            />
        </div>
    );
};

export default SelectAppender;
